module.exports = __webpack_public_path__ + "static/upgrade1-75e681b273d94eb496b7a4c1cb7e681f.png";